import WindowLocation from 'helpers/windowLocation'

class Environment {
  static isProduction () {
    return APP_ENV === 'production'
  }

  static isStaging () {
    return APP_ENV === 'staging'
  }

  static isQA () {
    return APP_ENV === 'qa'
  }

  static isQA2 () {
    return APP_ENV === 'qa2'
  }

  static isDevelopment () {
    return APP_ENV === 'development'
  }

  static env () {
    return APP_ENV
  }

  static goRthServiceURL () {
    return GO_RTH_SERVICE_URL || 'https://localhost:3000'
  }

  static backendApiURL () {
    const clientHostname = WindowLocation.hostname()

    if (clientHostname.match(/tr-dev.net$/)) {
      return 'https://qa2-diagnostics-api.tranehome.com'
    } else if (clientHostname.match(/tr-qa.net$/)) {
      return 'https://qa-diagnostics-api.tranehome.com'
    } else if (clientHostname.match(/tr-staging.net$/)) {
      return 'https://stage1-diagnostics-api.tranehome.com'
    } else if (clientHostname.match(/tranehome.net$/)) {
      return 'https://diagnostics-api.tranehome.com'
    }

    if (clientHostname === 'localhost' && WindowLocation.port() === '8090') {
      return 'http://localhost:8090'
    }

    const regex = /^(.*?)\./
    const backendHostname = 'https://' + clientHostname.replace(regex, '$1-api.')

    return backendHostname || 'https://localhost:3000'
  }

  static signOutURL () {
    return SIGN_OUT_URL || 'https://localhost:3000'
  }

  static isAWSCognito () {
    return USE_AWS_COGNITO === true
  }

  static webSocketURL () {
    return WEBSOCKET_URL || 'wss://dwa-ws.tr-dev.net'
  }

  static chatbotWebSocketURL () {
    return CHATBOT_WEBSOCKET_URL || 'wss://tech-assistant-socket-v2.tr-dev.net'
  }
}

export default Environment
